import Box from '@mui/material/Box'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { Button, CircularProgress, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Chip from '@mui/material/Chip'
import Skeleton from '@mui/material/Skeleton'
import MessageModal from '../MessageModal'
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout'
import usePricingTable from './hooks/usePricingTable'

export default function PricingTable({
    subscriptionsData,
    loading,
    token,
    reinstate,
    handleCancel,
    disabled,
}) {
    const {
        data,
        duration,
        handleChange,
        testMode,
        saveAmount,
        message,
        setMessage,
        subscriptionIncludes,
        checkoutMutation,
        handleCheckoutClick,
    } = usePricingTable({ subscriptionsData, token, reinstate, handleCancel, disabled })

    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            {!loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <ToggleButtonGroup
                        sx={{ m: 1 }}
                        color="primary"
                        value={duration}
                        exclusive
                        onChange={handleChange}
                        aria-label="Subsciption Duration"
                    >
                        <ToggleButton value="month">Monthly</ToggleButton>
                        <ToggleButton value="year">Yearly</ToggleButton>
                    </ToggleButtonGroup>
                    {testMode && (
                        <Chip
                            sx={{ display: 'flex', alignSelf: 'flex-start' }}
                            label="TEST MODE"
                            color="warning"
                            size="small"
                        />
                    )}
                    <Typography sx={{ mt: 2, mb: 2, textAlign: 'center' }} variant="h6">
                        Aircrew Port Pages Subscription Plan
                    </Typography>
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                            A${data[duration][0]?.unit_amount / 100}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', pl: '3px' }}>
                            <Typography variant="caption" color="darkgray">
                                per
                            </Typography>
                            <Typography variant="caption" color="darkgray">
                                {duration}
                            </Typography>
                        </Box>
                        {duration === 'year' ? (
                            <Chip
                                sx={{ display: 'flex', alignSelf: 'flex-start', m: 1 }}
                                label={`Save A$${saveAmount}`}
                                color="warning"
                                size="small"
                            />
                        ) : null}
                    </Box>
                    <Button
                        sx={{ mb: 2, mt: 2, width: '100%' }}
                        variant="contained"
                        onClick={handleCheckoutClick}
                        disabled={checkoutMutation.isPending}
                        startIcon={
                            checkoutMutation.isPending ? (
                                <CircularProgress size={20} />
                            ) : (
                                <ShoppingCartCheckoutIcon />
                            )
                        }
                    >
                        CHECKOUT
                    </Button>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignSelf: 'flex-start',
                        }}
                    >
                        <Typography sx={{ mb: 1 }} variant="body2">
                            This includes:
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
                            {subscriptionIncludes.map((item, index) => {
                                return (
                                    <Box sx={{ display: 'flex', pb: 0.5 }} key={index}>
                                        <CheckCircleIcon fontSize="small" />
                                        <Typography sx={{ ml: 1 }} variant="body2">
                                            {item}
                                        </Typography>
                                    </Box>
                                )
                            })}
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', width: '100%' }}>
                        <Button
                            onClick={handleCancel}
                            disabled={disabled || checkoutMutation.isPending}
                            variant="outlined"
                            fullWidth
                        >
                            CANCEL
                        </Button>
                    </Box>
                </Box>
            ) : (
                <Box>
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="rectangular" width={210} height={60} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                </Box>
            )}
            {message && <MessageModal message={message} setMessage={setMessage} />}
        </Box>
    )
}
